import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Menu, MenuCheckboxItem, MenuContent, MenuTrigger } from '@/components/molecules/Menu';

import styles from './DataTable.module.scss';

export interface ColumnMenuOption {
    id: string;
    label: ReactNode;
    visible: boolean;
}

export interface ColumnMenuProps {
    columns: ColumnMenuOption[];
    onToggle: (columnId: string, visible: boolean) => void;
}

/**
 * The "Columns" menu that shows and hides table columns. DataTable's toolbar builds it from
 * the table; a table that is not a DataTable passes its columns and visibility itself.
 */
export function ColumnMenu(props: ColumnMenuProps) {
    const { columns, onToggle } = props;
    const { t } = useTranslation();

    return (
        <Menu>
            <MenuTrigger variant="primary" caret>
                {t('organisms.dataTable.columns')}
            </MenuTrigger>
            <MenuContent className={styles.columnSelectorMenu}>
                {columns.map((column) => (
                    <MenuCheckboxItem
                        key={column.id}
                        checked={column.visible}
                        onCheckedChange={(checked) => onToggle(column.id, checked)}>
                        {column.label}
                    </MenuCheckboxItem>
                ))}
            </MenuContent>
        </Menu>
    );
}
